export enum RoleEnum {
    Admin = 'מנהל',
    Approver = 'מאשר',
    DepartmentManager = 'מנהל חטיבה',
    DepartmentReferent = 'רפרנט חטיבה',
    hrReferent = 'רפרנט מש"א',
    budgetReferent = 'רפרנט תקציב',
    ResearchAndDevelopment = 'פיתוח',
    user = 'משתמש רגיל',
}

export const roleMap = new Map<RoleEnum, string>([
    [RoleEnum.Admin, 'Admin'],
    [RoleEnum.Approver, 'Approver'],
    [RoleEnum.DepartmentManager, 'DepartmentManager'],
    [RoleEnum.DepartmentReferent, 'DepartmentReferent'],
    [RoleEnum.hrReferent, 'hrReferent'],
    [RoleEnum.budgetReferent, 'budgetReferent'],
    [RoleEnum.ResearchAndDevelopment, 'ResearchAndDevelopment'],
    [RoleEnum.user, 'user'],
]);
